import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { LayoutDesktop as Layout } from '@alfa-bank/site-layout/desktop';

import type { IStickyTableHeaderDeps, IStickyTableHeaderProps } from '../models';
import { Sticky } from '../../sticky';

import { StickyTableHeader as Component } from './sticky-table-header';

export const StickyTableHeader = createWidget<IStickyTableHeaderDeps, IStickyTableHeaderProps>({
    Sticky,
    Layout,
})(Component);
